import { InsightData } from 'schemas/action/InsightDataSchema'

export const sortByPerCapita = (insight1: InsightData, insight2: InsightData) =>
  insight2.perCapita! - insight1.perCapita!

export const sortByValue = (insight1: InsightData, insight2: InsightData) =>
  insight2.value! - insight1.value!
